import { OverlayWrapper } from './styles'
import { } from './styles'

interface IProps {
  visible: boolean,
  onClick?: () => void
}

const Overlay = (props: IProps) =>
  <OverlayWrapper
    visible={props.visible}
    onClick={props.onClick}
  />

export default Overlay
